module.exports = __webpack_public_path__ + "img/img_bear@2x.47e6e934.png";